export default __webpack_public_path__ + "static/media/alBanner0816.60cdb63a.png";